export default __webpack_public_path__ + "static/media/icon-whatsapp-ksa.0ab8fa3b.svg";